// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__5N24X","link":"Heading_link__D0Rho","icon":"Heading_icon__ZKeCG","large":"Heading_large__3FRB5","default":"Heading_default__oLKbM"};